import React, { useEffect, useState } from "react";
import Modal from "./Modal";
import { MODAL_CLOSE, PLACEHOLDER } from "src/constants/images";
import { NavLink } from "react-router-dom";

const IllustrationModal = ({
    onClose,
    isVisible,
    currentSelectedNFT,
    currentSelectedGangstaBet
}) => {

    useState(() => {
        console.warn("Currently selected gangstabet", currentSelectedGangstaBet);
    }, [currentSelectedGangstaBet]);

    const [isLoading, setLoading] = useState(true);

    return (
        <Modal
            isVisible={isVisible}
            overlayClass="overlay"
            className="illustration-modal card "
        >
            <div className="header px-4 py-3">
                <div>
                    <h4>Illustration Details</h4>
                    <p className="subTitle">Know your Illustration and its parent NFT. </p>
                </div>
                <div
                    onClick={() => onClose()}
                    onKeyPress={(e) => e.code == "Enter" && onClose()}
                    className="close-modal"
                >
                    <img src={MODAL_CLOSE.SOURCE} style={{ filter: "var(--close-white-btn)" }} alt="close" />
                </div>
            </div>
            <div className="px-3 illustration-full-details py-3">

                <div className="illustration-detail-inner">
                    {isLoading ? <p style={{ color: "#fff", fontSize: "16px", fontWeight: "bold" }}>Fetching NFT</p> : <p style={{ color: "#fff", fontSize: "16px", fontWeight: "bold" }}>{currentSelectedGangstaBet.name}</p>}

                    <p>Owned by: <span className="hex">{currentSelectedGangstaBet.owner_address?.slice(0, 4)}....{currentSelectedGangstaBet.owner_address?.slice(-4)}</span></p>
                    <img
                        src={isLoading ? PLACEHOLDER : import.meta.env.VITE_CLOUDFRONT_PREFIX + '/img/' + currentSelectedGangstaBet.index + ".gif"}
                        width={250}
                        className="hex mt-2"
                        onLoad={() => {
                            setTimeout(() => {
                                setLoading(false);
                            }, 3000);
                        }}
                    />

                    <NavLink to={`/profile/${currentSelectedNFT.gangstabet_id}`}><p className="hex mt-1">View profile</p></NavLink>
                </div>
                <div className="illustration-detail-inner">
                    <p style={{ color: "#fff", fontSize: "16px", fontWeight: "bold" }}>{currentSelectedNFT.name}</p>
                    <p>Owned by: <span className="hex">{currentSelectedGangstaBet.owner_address_illustration?.slice(0, 4)}....{currentSelectedGangstaBet.owner_address_illustration?.slice(-4)}</span></p>
                    <img src={currentSelectedNFT.image} width={250} className="hex mt-2" />
                    <p className="hex mt-1" onClick={() => {
                        window.open(`https://craft.network/nft/gangstabet-illustration:${currentSelectedNFT.id}`)
                    }}>View in Craft</p>
                </div>
            </div>
        </Modal>
    );
};

export default IllustrationModal;
